import React, { useEffect, useState } from 'react';
import { Modal } from '../../../../components';
import css from './ShippingModal.module.css';
import { FormattedMessage } from 'react-intl';
import getCountryCodes from '../../../../translations/countryCodes';
import config from '../../../../config';
import { Form, FieldSelect } from '../../../../components';
import { Form as FinalForm } from 'react-final-form';

const isDisabled = (country, sellerShippingCountries) => {
  if (!!sellerShippingCountries?.find(country => country === 'RoW')) {
    return false;
  } else {
    return !sellerShippingCountries?.some(c => c == country.code);
  }
};

function ShippingModal({
  setIsOpen,
  isOpen,
  handleSubmit,
  country,
  sellerId,
  sellerShippingCountries,
}) {
  const [formData, setFormData] = useState(country[sellerId]);

  useEffect(() => {
    setFormData(country[sellerId]);
  }, [sellerId]);

  const countryCodes = getCountryCodes(config.locale).filter(country => country.code !== 'RoW');

  return (
    <Modal
      id="shippingModal"
      onClose={() => setIsOpen(false)}
      onManageDisableScrolling={(id, what) => null}
      isOpen={isOpen}
      className={css.root}
    >
      <h2 className={css.modalTitle}>
        <FormattedMessage id="ShoppingCart.ShippingCost" />
      </h2>
      <FinalForm
        onSubmit={e => {
          e.preventDefault();
          handleSubmit(e, e.target.value, sellerId);
        }}
        render={fieldRenderProps => {
          return (
            <Form
              onSubmit={e => {
                handleSubmit(e, e.target[0].value, sellerId);
              }}
            >
              <label htmlFor="region" className={css.pickRegion}>
                <FormattedMessage id="ShoppingCart.PickRegion" />
              </label>

              <FieldSelect name="region" id="region" className={css.regionSelector}>
                {countryCodes.map(country => {
                  return (
                    <option
                      disabled={isDisabled(country, sellerShippingCountries)}
                      key={country.code}
                      value={country.code}
                    >
                      {country.name}
                    </option>
                  );
                })}
              </FieldSelect>

              <button className={css.saveButton} type="submit">
                <FormattedMessage id="ShoppingCart.Save" />
              </button>
            </Form>
          );
        }}
      />
    </Modal>
  );
}

ShippingModal.propTypes = {};

export default ShippingModal;
